import { render, staticRenderFns } from "./IconColumn.vue?vue&type=template&id=5c0b29c8&"
import script from "./IconColumn.vue?vue&type=script&lang=js&"
export * from "./IconColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c0b29c8')) {
      api.createRecord('5c0b29c8', component.options)
    } else {
      api.reload('5c0b29c8', component.options)
    }
    module.hot.accept("./IconColumn.vue?vue&type=template&id=5c0b29c8&", function () {
      api.rerender('5c0b29c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconColumn.vue"
export default component.exports